import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 供应商类型
 */
class SupplierType extends UltMeta {
    MINE = new Meta(1, "矿山");

    SAND_YARD = new Meta(2, "砂场");

    PROCESSING_PLANT = new Meta(3,"矿山加工厂");

    TRADER = new Meta(4, "贸易商");

    OTHER = new Meta(5, "其他");
}

export const ENTERPRISE_SUPPLIER_TYPE = new SupplierType();

/**
 * 展示位置
 * */
class ShowLocation extends UltMeta {
    ONE = new Meta(1, "合作矿厂位置1");

    TWO = new Meta(2, "合作矿厂位置2");

    THREE = new Meta(3, "合作矿厂位置3");

    FOUR = new Meta(4, "合作矿厂位置4");

    FIVE = new Meta(5, "合作矿厂位置5");

    SIX = new Meta(6, "合作矿厂位置6");

    SEVEN = new Meta(7, "合作矿厂位置7");

    EIGHT = new Meta(8, "合作矿厂位置8");
}

export const ENTERPRISE_SHOW_LOCATION = new ShowLocation();


/**
 * 供应商详情查询管理货源类型
 */
class SupplierProductType extends UltMeta {
    PICKING_UP_MISSING_PRODUCTS = new Meta(1, "捡漏商品");
    GROUP_BUYING_PRODUCTS = new Meta(2, "团购商品");
    CONSIGNMENT_PRODUCTS = new Meta(3, "寄售商品");
}
export const SUPPLIER_PRODUCT_TYPE = new SupplierProductType();
